import {BaseMatchedTransaction} from "../model/MatchedDocument";
import {jsonMapper} from "../utils/DataParser";
import {Nil} from "../utils/Types";

const PREFIX_KEY = "TransactionOverride"
const EXPIRE_AFTER_MINUTES = 180 * 24 * 60;

interface StoreObj {
    tx: BaseMatchedTransaction,
    expireAfter: Date
}

class TransactionOverride {

    constructor() {
        this.clearOldItems();
    }

    public getTransaction(iban: string, txId: string): BaseMatchedTransaction | Nil {
        const key = this.formatKey(iban, txId);
        const item = localStorage.getItem(key);
        if (item) {
            return jsonMapper.parse(item)?.tx;
        }
        return undefined
    }

    private formatKey(iban: string, txId: string) {
        return `${PREFIX_KEY}__${iban}__${txId}`;
    }

    private clearOldItems() {
        const date = new Date();
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)!!;
            if (key.includes(PREFIX_KEY)) {
                const item = jsonMapper.parse(localStorage.getItem(key)!!)
                if (item.expireAfter < date) {
                    localStorage.removeItem(key)
                }
            }
        }
    }

    public removeTransaction(iban: string, tx: BaseMatchedTransaction) {
        localStorage.removeItem(this.formatKey(iban, tx.tx.txId));
    }

    public setTransaction(iban: string, tx: BaseMatchedTransaction) {
        const expireAfter = new Date(new Date().getTime() + EXPIRE_AFTER_MINUTES * 60000)

        let obj: StoreObj = {
            tx: tx,
            expireAfter: expireAfter
        }

        localStorage.setItem(this.formatKey(iban, tx.tx.txId), jsonMapper.stringify(obj))
    }
}

export const transactionOverrideStore = new TransactionOverride();
